import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { getDriver } from "../../store/actions";
import { breadcrumbs, links } from "../../utils/constants";
import { getColorName } from "../../utils/utils";
import Breadcrumb from "../UI/Breadcrumb";
import PageTitle from "../UI/PageTitle";

const DriverInfoRow = props => (
  <li className="py-15">
    <p className="font-sm color-grey50">{props.label}</p>
    <p className="color-primary mt-5">{props.value}</p>
  </li>
);

class SingleDriver extends Component {
  componentDidMount() {
    const driverId = this.props.match.params.id;
    this.props.getDriver(driverId);
  }

  render() {
    const { driver } = this.props;
    if (!driver) return null;

    return (
      <React.Fragment>
        <PageTitle title="Driver Profile" />
        <div className="container">
          <Breadcrumb from={breadcrumbs.driver} current="Driver profile" />
        </div>
        <div className="container box inner-padding mb-15">
          <div className="box-body">
            <div className="row justify-between">
              <div className="col-xs-12">
                <div className="flex">
                  <div className="image-upload size-md my-20">
                    <div className="image">
                      <img src={driver.image} alt="placeholder" />
                    </div>
                  </div>
                  <ul className="ml-50 mt-10 w-700">
                    <DriverInfoRow
                      label="Driver First Name"
                      value={driver.firstName}
                    />
                    <DriverInfoRow
                      label="Driver Last Name"
                      value={driver.lastName}
                    />
                  </ul>
                </div>
              </div>
              <div className="col-xs-6 pr-70">
                <ul className="w-700">
                  <DriverInfoRow label="Driver ID" value={driver.id} />
                  <DriverInfoRow
                    label="Driver Iqama/Saudi ID"
                    value={driver.driverIqamaSaudiId}
                  />
                  <DriverInfoRow
                    label="Driver Mobile Number"
                    value={driver.mobileNumber}
                  />
                  <DriverInfoRow label="Driver Email" value={driver.email} />
                  <DriverInfoRow
                    label="Agreed Deposit"
                    value={driver.agreedDeposit}
                  />
                </ul>
              </div>
              <div className="col-xs-6 pl-70">
                <ul className="w-700">
                  <li className="py-15">
                    <p className="color-primary">Transport Description</p>

                    <ul className="flex w-700">
                      <DriverInfoRow
                        label="Year"
                        value={driver.transportYear}
                      />
                      <li className="py-15 ml-50">
                        <p className="font-sm color-grey50">Model</p>
                        <p className="color-primary mt-5">
                          {driver.transportModel}
                        </p>
                      </li>
                    </ul>
                  </li>
                  <DriverInfoRow
                    label="Transport Color"
                    value={getColorName(driver.transportColor)}
                  />
                  <DriverInfoRow
                    label="License Plate"
                    value={driver.licensePlate}
                  />
                  <DriverInfoRow
                    label="Employment Type"
                    value={driver.workType}
                  />
                  {driver.workType !== "Part-time" && (
                    <DriverInfoRow
                      label="Agreed Fixed Salary"
                      value={driver.agreedFixedSalary}
                    />
                  )}
                  <DriverInfoRow label="Driver Status" value={driver.status} />
                </ul>
              </div>
            </div>
          </div>
          <div className="box-meta">
            <div className="text-right">
              <Link
                to={links.editDriver(driver.id)}
                className="btn filled primary min-120"
              >
                <i className="fa fa-pencil font-sm mr-10" />
                Edit
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    driver: state.driver.selected
  };
};

export default connect(
  mapStateToProps,
  { getDriver }
)(SingleDriver);



// WEBPACK FOOTER //
// ./src/components/Driver/SingleDriver.js